import { Injectable } from '@angular/core';
import { Observable, map, catchError, tap, throwError } from 'rxjs';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { environment } from '@environments/environment';

@Injectable({
    providedIn: 'root',
})
export class UploadService {
    private apiUrl = environment.apiUrl + '/v1/file-uploads';

    constructor(private http: HttpClient) { }

    uploadFile(file: File): Observable<{ url: string }> {
        const formData = new FormData();
        formData.append('file', file, file.name);

        // Remove the headers option - let Angular set Content-Type automatically
        return this.http.post<any>(`${this.apiUrl}/upload`, formData).pipe(
            map(response => ({ url: response.url })),
            catchError(err => {
                console.error('File upload error:', err);
                return throwError(() =>
                    new Error('Failed to upload file: ' + (err.message || 'Unknown error'))
                );
            })
        );
    }

    uploadFiles(files: File[]): Observable<{ files: { fileName: string, url: string }[] }> {
        const formData = new FormData();

        // Append all files to FormData
        files.forEach(file => {
            formData.append('files', file, file.name);
        });

        // Remove the headers option - let Angular set Content-Type automatically
        return this.http.post<any>(`${this.apiUrl}/upload`, formData).pipe(
            map(response => ({ files: response.files })),
            catchError(err => {
                console.error('Files upload error:', err);
                return throwError(() =>
                    new Error('Failed to upload files: ' + (err.message || 'Unknown error'))
                );
            })
        );
    }
    uploadImage(file: File): Observable<{ url: string }> {
        const formData = new FormData();
        formData.append('file', file, file.name);

        // Remove the headers option - let Angular set Content-Type automatically
        return this.http.post<any>(`${this.apiUrl}/upload/images`, formData).pipe(
            map(response => ({ url: response.url })),
            catchError(err => {
                console.error('File upload error:', err);
                return throwError(() =>
                    new Error('Failed to upload file: ' + (err.message || 'Unknown error'))
                );
            })
        );
    }

    getLatestLink(): Observable<{ android: string, ios: string }> {
        return this.http.get<any>(`${this.apiUrl}/latest`).pipe(
            map(response => ({
                android: response.android,
                ios: response.ios
            })),
            catchError(err => {
                console.error('Get latest link error:', err);
                return throwError(() =>
                    new Error('Failed to get latest link: ' + (err.message || 'Unknown error'))
                );
            })
        );
    }
}